<!-- ============ shared SVG symbols (tea leaf) ============ -->
<svg class="ti-svg-defs" width="0" height="0" aria-hidden="true">
  <defs>
    <symbol id="ti-leaf" viewBox="0 0 40 80">
      <path
        fill="currentColor"
        d="M20 2c7 7 13 15 15 25l-1.6.8 1.8 1.2c.6 5 0 10-1.6 15l-1.8.2 1.2 1.6C31 55 26 65 20 78 14 65 9 55 6.2 46l1.2-1.6-1.8-.2C4 39.2 3.4 34 4 29l1.8-1.2L4.2 27C6.8 17 13 9 20 2z"
      />
      <path
        fill="none"
        stroke="#fff"
        stroke-opacity=".45"
        stroke-width="1.4"
        stroke-linecap="round"
        d="M20 8v66M20 22l8-6M20 22l-8-6M20 36l10-7M20 36l-10-7M20 50l9-6M20 50l-9-6M20 63l6-5M20 63l-6-5"
      />
    </symbol>
  </defs>
</svg>

<!-- ============ reusable dropzone template (TMCO certificate, cheque, signature) ============ -->
<ng-template
  #dropzoneTpl
  let-control="control"
  let-accept="accept"
  let-exts="exts"
  let-label="label"
  let-sub="sub"
  let-dragKey="dragKey"
>
  <input
    #dzInput
    type="file"
    class="ti-hidden-input"
    [attr.accept]="accept"
    (change)="handleFileInput($event, control, exts)"
  />

  <button
    *ngIf="!control.value"
    type="button"
    class="ti-dropzone"
    [class.ti-dropzone--drag]="isDragOver[dragKey]"
    (click)="dzInput.click()"
    (dragover)="onDragOver($event, dragKey)"
    (dragleave)="onDragLeave($event, dragKey)"
    (drop)="onFileDrop($event, control, dragKey, exts)"
  >
    <span class="ti-dropzone__icon">
      <svg
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.9"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M12 3v12"></path>
        <polyline points="7 8 12 3 17 8"></polyline>
        <path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2"></path>
      </svg>
    </span>
    <span class="ti-dropzone__label"
      ><em>{{ label }}</em> or drag and drop</span
    >
    <span class="ti-dropzone__sub">{{ sub }}</span>
  </button>

  <div *ngIf="control.value" class="ti-file-row">
    <div class="ti-file-row__info">
      <span class="ti-file-row__thumb">
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path
            d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"
          ></path>
          <polyline points="14 2 14 8 20 8"></polyline>
        </svg>
      </span>
      <span class="ti-file-row__meta">
        <span class="ti-file-row__name">{{ control.value?.name }}</span>
        <span class="ti-file-row__status">
          <svg
            width="12"
            height="12"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>
          {{ (control.value?.size || 0) / 1024 | number: "1.0-0" }} KB uploaded
        </span>
      </span>
    </div>
    <button
      type="button"
      class="ti-file-row__remove"
      aria-label="Remove file"
      (click)="removeFile(control)"
    >
      <svg
        width="16"
        height="16"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.9"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <path d="M4 7h16"></path>
        <path d="M10 11v6M14 11v6"></path>
        <path d="M6 7l1 13a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1l1-13"></path>
        <path d="M9 7V4h6v3"></path>
      </svg>
    </button>
  </div>
</ng-template>

<!-- ============ WIZARD ============ -->
<div class="ti-shell">
  <!-- ---------- sidebar ---------- -->
  <aside class="ti-sidebar">
    <div class="ti-sidebar__bg" aria-hidden="true">
      <svg class="ti-sidebar__bg-leaf ti-sidebar__bg-leaf--a">
        <use href="#ti-leaf"></use>
      </svg>
      <svg class="ti-sidebar__bg-leaf ti-sidebar__bg-leaf--b">
        <use href="#ti-leaf"></use>
      </svg>
    </div>

    <div class="ti-sidebar__brand">
      <span class="ti-sidebar__mark">
        <svg
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="1.9"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M11 20A7 7 0 0 1 4 13c0-6 7-11 15-11 0 9-4 15-11 18z"></path>
          <path d="M4 13c3 0 6-1 8-3"></path>
        </svg>
      </span>
      <div>
        <p class="ti-sidebar__title">Tea Inntech</p>
        <p class="ti-sidebar__subtitle">Seller onboarding</p>
      </div>
    </div>

    <ol class="ti-sidebar__steps">
      <li
        *ngFor="let s of steps; let i = index"
        class="ti-step"
        [class.ti-step--last]="i === steps.length - 1"
        [class.ti-step--active]="s.id === step"
        [class.ti-step--done]="isStepDone(s.id)"
      >
        <span
          *ngIf="i !== steps.length - 1"
          class="ti-step__line"
          [class.ti-step__line--done]="isStepDone(s.id)"
        ></span>

        <span
          class="ti-seal"
          [class.ti-seal--filled]="isStepDone(s.id)"
          [class.ti-seal--active]="s.id === step"
        >
          <!-- done -->
          <svg
            *ngIf="isStepDone(s.id)"
            class="ti-seal__check"
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="20 6 9 17 4 12"></polyline>
          </svg>

          <!-- active: step icon -->
          <ng-container *ngIf="s.id === step" [ngSwitch]="s.id">
            <svg
              *ngSwitchCase="1"
              class="ti-seal__icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.9"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <circle cx="12" cy="8" r="4"></circle>
              <path d="M4 21c0-4 4-7 8-7s8 3 8 7"></path>
            </svg>
            <svg
              *ngSwitchCase="2"
              class="ti-seal__icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.9"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="3" y="5" width="18" height="14" rx="2"></rect>
              <circle cx="9" cy="11" r="2"></circle>
              <path d="M6 16c.5-1.5 1.7-2 3-2s2.5.5 3 2"></path>
              <path d="M14 10h4M14 14h3"></path>
            </svg>
            <svg
              *ngSwitchCase="3"
              class="ti-seal__icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.9"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M3 21h18"></path>
              <path d="M5 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16"></path>
              <path d="M15 9h3a1 1 0 0 1 1 1v11"></path>
              <path d="M8 8h3M8 12h3M8 16h3"></path>
            </svg>
            <svg
              *ngSwitchCase="4"
              class="ti-seal__icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.9"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M3 10l9-6 9 6"></path>
              <path d="M5 10v8M9.5 10v8M14.5 10v8M19 10v8"></path>
              <path d="M3 21h18"></path>
            </svg>
            <svg
              *ngSwitchCase="5"
              class="ti-seal__icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.9"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M12 21s-7-6.2-7-12a7 7 0 0 1 14 0c0 5.8-7 12-7 12z"
              ></path>
              <circle cx="12" cy="9" r="2.5"></circle>
            </svg>
            <svg
              *ngSwitchCase="6"
              class="ti-seal__icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.9"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M3 17c3 0 4-9 6-9s1 8 3 8 2-4 4-4 2 3 5 3"></path>
              <path d="M3 21h18"></path>
            </svg>
            <svg
              *ngSwitchDefault
              class="ti-seal__icon"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="1.9"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect x="5" y="4" width="14" height="17" rx="2"></rect>
              <path d="M9 4V3h6v1"></path>
              <path d="M9 11h6M9 15h4"></path>
            </svg>
          </ng-container>

          <!-- upcoming -->
          <svg
            *ngIf="!isStepDone(s.id) && s.id !== step"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.9"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M11 20A7 7 0 0 1 4 13c0-6 7-11 15-11 0 9-4 15-11 18z"
            ></path>
            <path d="M4 13c3 0 6-1 8-3"></path>
          </svg>
        </span>

        <div class="ti-step__text">
          <p class="ti-step__index">{{ s.id < 10 ? "0" + s.id : s.id }}</p>
          <p
            class="ti-step__label"
            [class.ti-step__label--active]="s.id === step"
            [class.ti-step__label--done]="isStepDone(s.id)"
          >
            {{ s.label }}
          </p>
        </div>
      </li>
    </ol>

    <!-- tea cup progress -->
    <div class="ti-sidebar__help ti-cup-progress">
      <div class="ti-cup" aria-hidden="true">
        <svg viewBox="0 0 200 200">
          <defs>
            <clipPath id="ti-cup-clip">
              <path
                d="M46 64 H154 L145 168 Q143 178 132 178 H68 Q57 178 55 168 Z"
              ></path>
            </clipPath>
            <linearGradient id="ti-cup-tea" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0" stop-color="#E0A04A"></stop>
              <stop offset="1" stop-color="#8E5118"></stop>
            </linearGradient>
          </defs>
          <g class="ti-cup__steam">
            <path d="M80 50 C 70 38, 92 30, 80 14 S 86 -4, 80 -12"></path>
            <path d="M100 50 C 90 38, 112 30, 100 14 S 106 -4, 100 -12"></path>
            <path d="M120 50 C 110 38, 132 30, 120 14 S 126 -4, 120 -12"></path>
          </g>
          <path
            class="ti-cup__handle"
            d="M156 84 Q188 84 184 116 Q180 144 148 146"
          ></path>
          <path
            class="ti-cup__glass"
            d="M40 58 H160 L150 170 Q147 184 132 184 H68 Q53 184 50 170 Z"
          ></path>
          <g clip-path="url(#ti-cup-clip)">
            <g
              class="ti-cup__level"
              [style.transform]="'translateY(' + cupLevel + 'px)'"
            >
              <g class="ti-cup__wave">
                <path
                  d="M-120 6 Q-90 -4 -60 6 T0 6 T60 6 T120 6 T180 6 T240 6 T300 6 V200 H-120Z"
                  fill="url(#ti-cup-tea)"
                ></path>
              </g>
              <svg
                class="ti-cup__leaf"
                x="108"
                y="-8"
                width="14"
                height="26"
                viewBox="0 0 40 80"
              >
                <use href="#ti-leaf"></use>
              </svg>
            </g>
          </g>
          <path class="ti-cup__shine" d="M58 72 L66 160"></path>
        </svg>
      </div>
      <div>
        <p class="ti-cup-progress__pct">{{ progressPct }}%</p>
        <p class="ti-sidebar__help-label">complete</p>
        <p class="ti-sidebar__help-value">
          Need help?
          <a href="mailto:support@teainntech.in">Email support</a>
        </p>
      </div>
    </div>
  </aside>

  <!-- ---------- main ---------- -->
  <main class="ti-main">
    <!-- tea estate hills -->
    <div class="ti-estate" aria-hidden="true">
      <svg viewBox="0 0 1200 400" preserveAspectRatio="xMidYMax slice">
        <defs>
          <pattern
            id="ti-rows"
            width="26"
            height="14"
            patternUnits="userSpaceOnUse"
            patternTransform="rotate(-8)"
          >
            <ellipse
              cx="13"
              cy="8"
              rx="10"
              ry="4.5"
              fill="#2F8B69"
              opacity=".14"
            ></ellipse>
          </pattern>
          <linearGradient id="ti-fade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stop-color="#F6EBD8" stop-opacity="1"></stop>
            <stop offset=".45" stop-color="#F6EBD8" stop-opacity="0"></stop>
          </linearGradient>
        </defs>
        <path
          d="M0 210 C 180 150, 360 170, 520 200 S 860 150, 1200 190 V400 H0Z"
          fill="#9CC5A9"
          opacity=".28"
        ></path>
        <path
          d="M0 260 C 220 210, 420 250, 640 240 S 980 200, 1200 250 V400 H0Z"
          fill="#6FAE8B"
          opacity=".22"
        ></path>
        <path
          d="M0 260 C 220 210, 420 250, 640 240 S 980 200, 1200 250 V400 H0Z"
          fill="url(#ti-rows)"
        ></path>
        <path
          d="M0 320 C 260 280, 520 330, 760 300 S 1060 290, 1200 310 V400 H0Z"
          fill="#2F8B69"
          opacity=".18"
        ></path>
        <path
          d="M0 320 C 260 280, 520 330, 760 300 S 1060 290, 1200 310 V400 H0Z"
          fill="url(#ti-rows)"
        ></path>
        <rect width="1200" height="400" fill="url(#ti-fade)"></rect>
      </svg>
    </div>

    <!-- drifting leaves -->
    <div class="ti-leaves" aria-hidden="true">
      <span class="ti-leaf"
        ><svg><use href="#ti-leaf"></use></svg
      ></span>
      <span class="ti-leaf"
        ><svg><use href="#ti-leaf"></use></svg
      ></span>
      <span class="ti-leaf"
        ><svg><use href="#ti-leaf"></use></svg
      ></span>
      <span class="ti-leaf"
        ><svg><use href="#ti-leaf"></use></svg
      ></span>
      <span class="ti-leaf"
        ><svg><use href="#ti-leaf"></use></svg
      ></span>
      <span class="ti-leaf"
        ><svg><use href="#ti-leaf"></use></svg
      ></span>
      <span class="ti-leaf"
        ><svg><use href="#ti-leaf"></use></svg
      ></span>
      <span class="ti-leaf"
        ><svg><use href="#ti-leaf"></use></svg
      ></span>
    </div>

    <div class="ti-main__inner">
      <div class="ti-mobile-step ti-topbar">
        <p>
          Step <b>{{ step }}</b> of 7
        </p>
        <p class="ti-topbar__name">{{ steps[step - 1].label }}</p>
      </div>

      <div class="ti-progress">
        <div class="ti-progress__bar" [style.width.%]="(step / 7) * 100"></div>
      </div>

      <div class="ti-card" [formGroup]="form">
        <svg class="ti-card__leaf" aria-hidden="true">
          <use href="#ti-leaf"></use>
        </svg>

        <!-- ---------- STEP 1: Account ---------- -->
        <ng-container *ngIf="step === 1" formGroupName="account">
          <section class="ti-pane">
            <h2 class="ti-heading">Account details</h2>
            <p class="ti-desc">
              Who should we contact about this seller account? You'll sign in
              with this email and password.
            </p>

            <div class="ti-field">
              <label class="ti-label"
                >Contact person <span class="ti-required">*</span></label
              >
              <input
                class="ti-input form-control"
                type="text"
                placeholder="Full name"
                formControlName="name"
                [class.is-invalid]="
                  form.get('account.name')?.invalid && touched && step == 1
                "
              />
              <div class="invalid-feedback">This field is required</div>
            </div>

            <div class="ti-grid-2">
              <div class="ti-field">
                <label class="ti-label"
                  >Contact number <span class="ti-required">*</span></label
                >
                <div class="ti-ctl">
                  <span class="ti-ctl__pre">+91</span>
                  <input
                    class="ti-input"
                    type="text"
                    placeholder="10-digit mobile number"
                    maxlength="10"
                    inputmode="numeric"
                    formControlName="mobile"
                    [class.is-invalid]="
                      form.get('account.mobile')?.invalid &&
                      touched &&
                      step == 1
                    "
                  />
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="form.get('account.mobile')?.hasError('required')"
                >
                  This field is required
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="form.get('account.mobile')?.hasError('pattern')"
                >
                  Not Valid Mobile No
                </div>
              </div>
              <div class="ti-field">
                <label class="ti-label"
                  >Email ID <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input"
                  type="email"
                  placeholder="name&#64;company.com"
                  formControlName="email"
                  [class.is-invalid]="
                    form.get('account.email')?.invalid && touched && step == 1
                  "
                />
                <div
                  class="invalid-feedback"
                  *ngIf="form.get('account.email')?.hasError('required')"
                >
                  This field is required
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="form.get('account.email')?.hasError('email')"
                >
                  Not a Valid Email Address
                </div>
              </div>
            </div>

            <div class="ti-grid-2">
              <div class="ti-field">
                <label class="ti-label"
                  >Create password <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input"
                  type="password"
                  placeholder="At least 8 characters"
                  formControlName="password"
                  [class.is-invalid]="
                    form.get('account.password')?.invalid &&
                    touched &&
                    step == 1
                  "
                />
                <div
                  class="invalid-feedback"
                  *ngIf="form.get('account.password')?.hasError('required')"
                >
                  This field is required
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="form.get('account.password')?.hasError('minlength')"
                >
                  Password must be at least 8 characters long.
                </div>
              </div>
              <div class="ti-field">
                <label class="ti-label"
                  >Confirm password <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input"
                  type="password"
                  placeholder="Re-enter password"
                  formControlName="confirmPassword"
                  [class.is-invalid]="
                    form.get('account.confirmPassword')?.invalid &&
                    touched &&
                    step == 1
                  "
                />
                <div
                  class="invalid-feedback"
                  *ngIf="
                    form.get('account.confirmPassword')?.hasError('required')
                  "
                >
                  This field is required
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    form.get('account.confirmPassword')?.hasError('minlength')
                  "
                >
                  Confirm Password must be at least 8 characters long
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="form.get('account')?.hasError('passwordMismatch')"
                >
                  Passwords do not match.
                </div>
              </div>
            </div>
          </section>
        </ng-container>

        <!-- ---------- STEP 2: Business verification ---------- -->
        <ng-container *ngIf="step === 2" formGroupName="company_info">
          <section class="ti-pane">
            <h2 class="ti-heading">GST details</h2>
            <p class="ti-desc">
              Enter your GSTIN and we'll fetch your PAN, legal name and
              registered address automatically.
            </p>

            <div class="ti-field">
              <label class="ti-label"
                >GSTIN <span class="ti-required">*</span></label
              >
              <div class="ti-gst-row">
                <input
                  class="ti-input ti-input--upper"
                  type="text"
                  placeholder="e.g. 33AAAPT1234C1Z5"
                  maxlength="15"
                  formControlName="company_gst_no"
                  [class.is-invalid]="
                    companyInfoGroup.get('company_gst_no')?.invalid &&
                    touched &&
                    step == 2
                  "
                />
                <button
                  type="button"
                  class="ti-btn ti-btn--forest ti-gst-btn"
                  [disabled]="!companyInfoGroup.get('company_gst_no')?.valid"
                  (click)="verifyGst()"
                >
                  <ng-container *ngIf="gstVerifying; else verifyLabel">
                    <svg
                      class="ti-spin"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M21 12a9 9 0 1 1-9-9"></path>
                    </svg>
                    Verifying
                  </ng-container>
                  <ng-template #verifyLabel>
                    <svg
                      width="17"
                      height="17"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.9"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path
                        d="M12 3l7 3v6c0 5-3.5 8-7 9-3.5-1-7-4-7-9V6l7-3z"
                      ></path>
                      <polyline points="9 12 11 14 15 10"></polyline>
                    </svg>
                    Verify GST
                  </ng-template>
                </button>
              </div>
              <div
                class="invalid-feedback"
                *ngIf="
                  companyInfoGroup.get('company_gst_no')?.hasError('required')
                "
              >
                This field is required
              </div>
              <div
                class="invalid-feedback"
                *ngIf="
                  companyInfoGroup.get('company_gst_no')?.hasError('pattern')
                "
              >
                Not a valid GSTIN
              </div>
              <p class="ti-hint">15-character GST identification number</p>
            </div>

            <div *ngIf="gstVerified" class="ti-panel">
              <p class="ti-panel__title">
                <svg
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.9"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path
                    d="M12 3l7 3v6c0 5-3.5 8-7 9-3.5-1-7-4-7-9V6l7-3z"
                  ></path>
                  <polyline points="9 12 11 14 15 10"></polyline>
                </svg>
                Fetched from GSTN records
              </p>

              <div class="ti-field">
                <label class="ti-label"
                  >PAN <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input ti-input--upper"
                  type="text"
                  formControlName="company_pan_no"
                  [class.is-invalid]="
                    companyInfoGroup.get('company_pan_no')?.invalid &&
                    touched &&
                    step == 2
                  "
                />
                <div
                  class="invalid-feedback"
                  *ngIf="
                    companyInfoGroup.get('company_pan_no')?.hasError('required')
                  "
                >
                  This field is required
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    companyInfoGroup.get('company_pan_no')?.hasError('pattern')
                  "
                >
                  Not a valid PAN No
                </div>
              </div>
              <div class="ti-field">
                <label class="ti-label"
                  >Company / legal name
                  <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input"
                  type="text"
                  placeholder="As registered with GSTN"
                  formControlName="company_name"
                  [class.is-invalid]="
                    companyInfoGroup.get('company_name')?.invalid &&
                    touched &&
                    step == 2
                  "
                />
                <div class="invalid-feedback">This field is required</div>
              </div>
              <div class="ti-field ti-field--last">
                <label class="ti-label"
                  >Registered address <span class="ti-required">*</span></label
                >
                <textarea
                  class="ti-input ti-textarea"
                  rows="2"
                  placeholder="Principal place of business"
                  formControlName="company_address"
                  [class.is-invalid]="
                    companyInfoGroup.get('company_address')?.invalid &&
                    touched &&
                    step == 2
                  "
                ></textarea>
                <div class="invalid-feedback">This field is required</div>
              </div>

              <p class="ti-hint ti-hint--top">
                Not quite right? You can edit any field above before continuing.
              </p>
            </div>
          </section>
        </ng-container>

        <!-- ---------- STEP 3: Company details ---------- -->
        <ng-container *ngIf="step === 3" formGroupName="company">
          <section class="ti-pane">
            <h2 class="ti-heading">Company details</h2>
            <p class="ti-desc">
              Your Tea Marketing Control Order (Garden) registration and brand
              assets.
            </p>
            <label class="ti-label"
              >Gardens <span class="ti-required">*</span></label
            >
            <tag-input
              class="ti-tag-input mb-1"
              [class.is-invalid]="
                companyGroup.get('gardens')?.invalid && touched && step == 3
              "
              formControlName="gardens"
              [modelAsStrings]="true"
              [onlyFromAutocomplete]="false"
              [separatorKeyCodes]="[13, 9, 188]"
              [addOnBlur]="true"
              theme="bootstrap"
              placeholder="+ Garden"
              secondaryPlaceholder="Add gardens"
            >
            </tag-input>
            <div
              class="invalid-feedback"
              *ngIf="
                companyGroup.get('gardens')?.invalid && touched && step == 3
              "
            >
              Add at least one garden
            </div>
            <div class="ti-field">
              <label class="ti-label"
                >TMCO number <span class="ti-optional">(optional)</span></label
              >
              <input
                class="ti-input ti-input--upper"
                type="text"
                placeholder="e.g. TMCO/2024/00123"
                formControlName="tmco"
              />
              <p class="ti-hint">
                As issued under the Tea Marketing Control Order
              </p>
            </div>

            <div class="ti-field">
              <label class="ti-label"
                >TMCO certificate
                <span class="ti-optional">(optional)</span></label
              >
              <ng-container
                *ngTemplateOutlet="
                  dropzoneTpl;
                  context: {
                    control: companyGroup.get('tmco_file'),
                    accept: '.pdf',
                    exts: PDF_EXTENSIONS,
                    label: 'Click to upload',
                    sub: 'PDF only, up to 5MB',
                    dragKey: 'tmcoCert',
                  }
                "
              ></ng-container>
              <p class="ti-hint">
                Upload a scanned copy of your TMCO registration certificate
              </p>
            </div>

            <div class="ti-field">
              <label class="ti-label"
                >Company logo <span class="ti-required">*</span></label
              >

              <div *ngIf="logoPreview; else logoDrop" class="ti-logo-row">
                <img
                  [src]="logoPreview"
                  alt="Logo preview"
                  class="ti-logo-row__img"
                />
                <div class="ti-logo-row__meta">
                  <p class="ti-logo-row__name">
                    {{ companyGroup.get("logo")!.value?.name }}
                  </p>
                  <span class="ti-file-row__status">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="3"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                    {{
                      (companyGroup.get("logo")!.value?.size || 0) / 1024
                        | number: "1.0-0"
                    }}
                    KB uploaded
                  </span>
                </div>
                <button
                  type="button"
                  class="ti-link-danger"
                  (click)="removeLogo()"
                >
                  Remove
                </button>
              </div>

              <ng-template #logoDrop>
                <input
                  #logoInput
                  type="file"
                  class="ti-hidden-input ti-input"
                  accept="image/*"
                  (change)="onLogoChange($event)"
                  [class.is-invalid]="
                    companyGroup.get('logo')?.invalid && touched && step == 3
                  "
                />

                <button
                  type="button"
                  class="ti-dropzone"
                  [class.ti-dropzone--drag]="isDragOver['logo']"
                  (click)="logoInput.click()"
                  (dragover)="onDragOver($event, 'logo')"
                  (dragleave)="onDragLeave($event, 'logo')"
                  (drop)="onLogoDrop($event)"
                >
                  <span class="ti-dropzone__icon">
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="1.9"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <rect x="3" y="4" width="18" height="16" rx="2"></rect>
                      <circle cx="9" cy="10" r="2"></circle>
                      <path d="M21 16l-5-5-9 9"></path>
                    </svg>
                  </span>
                  <span class="ti-dropzone__label"
                    ><em>Upload company logo</em></span
                  >
                  <span class="ti-dropzone__sub"
                    >PNG or JPG, square image recommended</span
                  >
                </button>

                <div class="invalid-feedback">This field is required</div>
              </ng-template>

              <p class="ti-hint">
                Used on your seller storefront, invoices and offer sheets
              </p>
            </div>
          </section>
        </ng-container>

        <!-- ---------- STEP 4: Bank details ---------- -->
        <ng-container *ngIf="step === 4" formGroupName="bank">
          <section class="ti-pane">
            <h2 class="ti-heading">Bank details</h2>
            <p class="ti-desc">
              Auction proceeds are settled to this account via NEFT / RTGS.
            </p>

            <div class="ti-grid-2">
              <div class="ti-field">
                <label class="ti-label"
                  >Account holder name <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input"
                  type="text"
                  placeholder="As printed on cheque"
                  formControlName="accountHolder"
                  [class.is-invalid]="
                    bankGroup.get('accountHolder')?.invalid &&
                    touched &&
                    step == 4
                  "
                />
                <div class="invalid-feedback">This field is required</div>
              </div>
              <div class="ti-field">
                <label class="ti-label"
                  >Bank name <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input"
                  type="text"
                  placeholder="e.g. State Bank of India"
                  formControlName="bankName"
                  [class.is-invalid]="
                    bankGroup.get('bankName')?.invalid && touched && step == 4
                  "
                />
                <div class="invalid-feedback">This field is required</div>
              </div>
            </div>

            <div class="ti-field">
              <label class="ti-label"
                >Branch <span class="ti-required">*</span></label
              >
              <input
                class="ti-input"
                type="text"
                placeholder="Branch name or location"
                formControlName="branch"
                [class.is-invalid]="
                  bankGroup.get('branch')?.invalid && touched && step == 4
                "
              />
              <div class="invalid-feedback">This field is required</div>
            </div>

            <div class="ti-grid-2">
              <div class="ti-field">
                <label class="ti-label"
                  >Account number <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input"
                  type="text"
                  inputmode="numeric"
                  formControlName="accountNumber"
                  [class.is-invalid]="
                    bankGroup.get('accountNumber')?.invalid &&
                    touched &&
                    step == 4
                  "
                />
                <div
                  class="invalid-feedback"
                  *ngIf="bankGroup.get('accountNumber')?.hasError('required')"
                >
                  This field is required
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="bankGroup.get('accountNumber')?.hasError('pattern')"
                >
                  Not a Valid Account No
                </div>
              </div>
              <div class="ti-field">
                <label class="ti-label"
                  >IFSC code <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input ti-input--upper"
                  type="text"
                  placeholder="e.g. SBIN0001234"
                  formControlName="ifsc"
                  [class.is-invalid]="
                    bankGroup.get('ifsc')?.invalid && touched && step == 4
                  "
                />
                <div class="invalid-feedback">This field is required</div>
              </div>
            </div>

            <div class="ti-field">
              <label class="ti-label"
                >Cancelled cheque
                <span class="ti-optional">(optional)</span></label
              >
              <ng-container
                *ngTemplateOutlet="
                  dropzoneTpl;
                  context: {
                    control: bankGroup.get('cheque'),
                    accept: 'image/*',
                    exts: IMAGE_EXTENSIONS,
                    label: 'Click to upload',
                    sub: 'JPG or PNG, up to 5MB',
                    dragKey: 'cheque',
                  }
                "
              ></ng-container>
              <p class="ti-hint">Optional, but speeds up bank verification</p>
            </div>
          </section>
        </ng-container>

        <!-- ---------- STEP 5: Locations ---------- -->
        <ng-container *ngIf="step === 5" formGroupName="locations">
          <section class="ti-pane">
            <h2 class="ti-heading">Locations</h2>
            <p class="ti-desc">
              Where should dispatches originate, and where can our field
              inspector find your garden or factory?
            </p>

            <p class="ti-subheading">
              <span class="ti-subheading__icon">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="1.9"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M3 21h18"></path>
                  <path d="M5 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16"></path>
                  <path d="M15 9h3a1 1 0 0 1 1 1v11"></path>
                  <path d="M8 8h3M8 12h3M8 16h3"></path>
                </svg>
              </span>
              Shipping location
            </p>

            <div class="ti-field">
              <label class="ti-label"
                >Address <span class="ti-required">*</span></label
              >
              <input
                class="ti-input"
                type="text"
                placeholder="Shipping address"
                formControlName="ship_to_address"
                [class.is-invalid]="
                  locationsGroup.get('ship_to_address')?.invalid &&
                  touched &&
                  step == 5
                "
              />
              <div class="invalid-feedback">This field is required</div>
            </div>
            <div class="ti-grid-3">
              <div class="ti-field">
                <label class="ti-label"
                  >City <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input"
                  type="text"
                  placeholder="City"
                  formControlName="ship_city"
                  [class.is-invalid]="
                    locationsGroup.get('ship_city')?.invalid &&
                    touched &&
                    step == 5
                  "
                />
                <div class="invalid-feedback">This field is required</div>
              </div>
              <div class="ti-field">
                <label class="ti-label"
                  >State <span class="ti-required">*</span></label
                >
                <select
                  class="ti-input ti-select"
                  formControlName="ship_state"
                  [class.is-invalid]="
                    locationsGroup.get('ship_state')?.invalid &&
                    touched &&
                    step == 5
                  "
                >
                  <option value="">Select state</option>
                  <option *ngFor="let s of states" [value]="s">{{ s }}</option>
                </select>
                <div class="invalid-feedback">This field is required</div>
              </div>
              <div class="ti-field">
                <label class="ti-label"
                  >Pincode <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input"
                  type="text"
                  maxlength="6"
                  inputmode="numeric"
                  placeholder="6-digit pincode"
                  formControlName="ship_pincode"
                  [class.is-invalid]="
                    locationsGroup.get('ship_pincode')?.invalid &&
                    touched &&
                    step == 5
                  "
                />
                <div
                  class="invalid-feedback"
                  *ngIf="
                    locationsGroup.get('ship_pincode')?.hasError('required')
                  "
                >
                  This field is required
                </div>
                <div
                  class="invalid-feedback"
                  *ngIf="
                    locationsGroup.get('ship_pincode')?.hasError('pattern')
                  "
                >
                  Not a valid Pin Code
                </div>
              </div>
            </div>

            <div class="ti-divider"></div>

            <div class="ti-row-between">
              <p class="ti-subheading ti-subheading--tight">
                <span class="ti-subheading__icon">
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.9"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M11 20A7 7 0 0 1 4 13c0-6 7-11 15-11 0 9-4 15-11 18z"
                    ></path>
                    <path d="M4 13c3 0 6-1 8-3"></path>
                  </svg>
                </span>
                Factory / garden location
              </p>
              <label class="ti-checkbox-inline ti-switch">
                <input type="checkbox" formControlName="sameAsShip" />
                <span class="ti-switch__track"></span>
                Same as shipping location
              </label>
            </div>

            <div
              class="ti-loc-box"
              [class.ti-loc-box--muted]="
                locationsGroup.get('sameAsShip')?.value
              "
            >
              <div class="ti-field">
                <label class="ti-label"
                  >Address <span class="ti-required">*</span></label
                >
                <input
                  class="ti-input"
                  type="text"
                  placeholder="Garden or factory address"
                  formControlName="bill_to_address"
                  [class.is-invalid]="
                    locationsGroup.get('bill_to_address')?.invalid &&
                    touched &&
                    step == 5
                  "
                />
                <div class="invalid-feedback">This field is required</div>
              </div>
              <div class="ti-grid-3">
                <div class="ti-field">
                  <label class="ti-label"
                    >City <span class="ti-required">*</span></label
                  >
                  <input
                    class="ti-input"
                    type="text"
                    placeholder="City"
                    formControlName="bill_city"
                    [class.is-invalid]="
                      locationsGroup.get('bill_city')?.invalid &&
                      touched &&
                      step == 5
                    "
                  />
                  <div class="invalid-feedback">This field is required</div>
                </div>
                <div class="ti-field">
                  <label class="ti-label"
                    >State <span class="ti-required">*</span></label
                  >
                  <select
                    class="ti-input ti-select"
                    formControlName="bill_state"
                    [class.is-invalid]="
                      locationsGroup.get('bill_state')?.invalid &&
                      touched &&
                      step == 5
                    "
                  >
                    <option value="">Select state</option>
                    <option *ngFor="let s of states" [value]="s">
                      {{ s }}
                    </option>
                  </select>
                  <div class="invalid-feedback">This field is required</div>
                </div>
                <div class="ti-field">
                  <label class="ti-label"
                    >Pincode <span class="ti-required">*</span></label
                  >
                  <input
                    class="ti-input"
                    type="text"
                    maxlength="6"
                    inputmode="numeric"
                    placeholder="6-digit pincode"
                    formControlName="bill_pincode"
                    [class.is-invalid]="
                      locationsGroup.get('bill_pincode')?.invalid &&
                      touched &&
                      step == 5
                    "
                  />
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      locationsGroup.get('bill_pincode')?.hasError('required')
                    "
                  >
                    This field is required
                  </div>
                  <div
                    class="invalid-feedback"
                    *ngIf="
                      locationsGroup.get('bill_pincode')?.hasError('pattern')
                    "
                  >
                    Not a valid Pin Code
                  </div>
                </div>
              </div>
            </div>

            <p class="ti-hint ti-hint--tight">
              A Tea Inntech field inspector will visit this location as part of
              verification.
            </p>
          </section>
        </ng-container>

        <!-- ---------- STEP 6: Digital signature (PDF only) ---------- -->
        <ng-container *ngIf="step === 6" formGroupName="signature">
          <section class="ti-pane">
            <h2 class="ti-heading">Digital signature</h2>
            <p class="ti-desc">
              This signature will be used on your tax invoices, e-invoices and
              the engagement letter.
            </p>

            <div class="ti-field ti-sig-field">
              <label class="ti-label"
                >Signature <span class="ti-required">*</span></label
              >
              <ng-container
                *ngTemplateOutlet="
                  dropzoneTpl;
                  context: {
                    control: signatureGroup.get('signatureFile'),
                    accept: '.pdf,application/pdf',
                    exts: PDF_EXTENSIONS,
                    label: 'Upload signature PDF',
                    sub: 'PDF only, up to 5MB',
                    dragKey: 'signature',
                  }
                "
              ></ng-container>
              <p class="ti-hint">
                Sign on white paper, scan it as a PDF, and crop close to the
                signature
              </p>
            </div>
          </section>
        </ng-container>

        <!-- ---------- STEP 7: Review & submit ---------- -->
        <ng-container *ngIf="step === 7" formGroupName="review">
          <section class="ti-pane">
            <h2 class="ti-heading">Review and sign up</h2>
            <p class="ti-desc">
              Check everything once before creating your seller account. Use
              Edit to jump back to any section.
            </p>

            <div class="ti-review">
              <!-- Account -->
              <div class="ti-review-row">
                <div class="ti-review-row__head">
                  <p class="ti-review-row__title">
                    <span class="ti-review-row__icon">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <circle cx="12" cy="8" r="4"></circle>
                        <path d="M4 21c0-4 4-7 8-7s8 3 8 7"></path>
                      </svg>
                    </span>
                    Account details
                  </p>
                  <button type="button" class="ti-link" (click)="goToStep(1)">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M4 20h4L19 9l-4-4L4 16v4z"></path>
                      <path d="M14 6l4 4"></path>
                    </svg>
                    Edit
                  </button>
                </div>
                <div class="ti-review-row__body">
                  <p class="ti-review-line">
                    <span>Contact person</span
                    >{{ accountGroup.get("name")!.value || "—" }}
                  </p>
                  <p class="ti-review-line">
                    <span>Contact number</span
                    >{{
                      accountGroup.get("mobile")!.value
                        ? "+91 " + accountGroup.get("mobile")!.value
                        : "—"
                    }}
                  </p>
                  <p class="ti-review-line ti-review-line--wide">
                    <span>Email ID</span
                    >{{ accountGroup.get("email")!.value || "—" }}
                  </p>
                </div>
              </div>

              <!-- Business -->
              <div class="ti-review-row">
                <div class="ti-review-row__head">
                  <p class="ti-review-row__title">
                    <span class="ti-review-row__icon">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <rect x="3" y="5" width="18" height="14" rx="2"></rect>
                        <circle cx="9" cy="11" r="2"></circle>
                        <path d="M14 10h4M14 14h3"></path>
                      </svg>
                    </span>
                    Business verification
                  </p>
                  <button type="button" class="ti-link" (click)="goToStep(2)">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M4 20h4L19 9l-4-4L4 16v4z"></path>
                      <path d="M14 6l4 4"></path>
                    </svg>
                    Edit
                  </button>
                </div>
                <div class="ti-review-row__body">
                  <p class="ti-review-line">
                    <span>GSTIN</span
                    >{{ companyInfoGroup.get("company_gst_no")!.value || "—" }}
                  </p>
                  <p class="ti-review-line">
                    <span>PAN</span
                    >{{ companyInfoGroup.get("company_pan_no")!.value || "—" }}
                  </p>
                  <p class="ti-review-line ti-review-line--wide">
                    <span>Company / legal name</span
                    >{{ companyInfoGroup.get("company_name")!.value || "—" }}
                  </p>
                </div>
              </div>

              <!-- Company -->
              <div class="ti-review-row">
                <div class="ti-review-row__head">
                  <p class="ti-review-row__title">
                    <span class="ti-review-row__icon">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M3 21h18"></path>
                        <path
                          d="M5 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16"
                        ></path>
                        <path d="M15 9h3a1 1 0 0 1 1 1v11"></path>
                      </svg>
                    </span>
                    Company details
                  </p>
                  <button type="button" class="ti-link" (click)="goToStep(3)">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M4 20h4L19 9l-4-4L4 16v4z"></path>
                      <path d="M14 6l4 4"></path>
                    </svg>
                    Edit
                  </button>
                </div>
                <div class="ti-review-row__body">
                  <p class="ti-review-line">
                    <span>Gardens</span
                    >{{ companyGroup.get("gardens")!.value || "—" }}
                  </p>
                  <p class="ti-review-line">
                    <span>TMCO number</span
                    >{{ companyGroup.get("tmco")!.value || "—" }}
                  </p>
                  <p class="ti-review-line">
                    <span>TMCO certificate</span
                    >{{ companyGroup.get("tmco_file")!.value?.name || "—" }}
                  </p>
                  <div class="ti-review-line ti-review-line--wide">
                    <span>Company logo</span>
                    <img
                      *ngIf="logoPreview; else noLogo"
                      [src]="logoPreview"
                      alt="Company logo"
                      class="ti-review-logo"
                    />
                    <ng-template #noLogo>Not uploaded</ng-template>
                  </div>
                </div>
              </div>

              <!-- Bank -->
              <div class="ti-review-row">
                <div class="ti-review-row__head">
                  <p class="ti-review-row__title">
                    <span class="ti-review-row__icon">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M3 10l9-6 9 6"></path>
                        <path d="M5 10v8M9.5 10v8M14.5 10v8M19 10v8"></path>
                        <path d="M3 21h18"></path>
                      </svg>
                    </span>
                    Bank details
                  </p>
                  <button type="button" class="ti-link" (click)="goToStep(4)">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M4 20h4L19 9l-4-4L4 16v4z"></path>
                      <path d="M14 6l4 4"></path>
                    </svg>
                    Edit
                  </button>
                </div>
                <div class="ti-review-row__body">
                  <p class="ti-review-line">
                    <span>Account holder</span
                    >{{ bankGroup.get("accountHolder")!.value || "—" }}
                  </p>
                  <p class="ti-review-line">
                    <span>Account</span
                    >{{
                      bankGroup.get("bankName")!.value
                        ? bankGroup.get("bankName")!.value +
                          " · " +
                          bankGroup.get("accountNumber")!.value
                        : "—"
                    }}
                  </p>
                  <p class="ti-review-line">
                    <span>Branch</span
                    >{{ bankGroup.get("branch")!.value || "—" }}
                  </p>
                  <p class="ti-review-line">
                    <span>IFSC code</span
                    >{{ bankGroup.get("ifsc")!.value || "—" }}
                  </p>
                  <p class="ti-review-line ti-review-line--wide">
                    <span>Cancelled cheque</span
                    >{{ bankGroup.get("cheque")!.value?.name || "—" }}
                  </p>
                </div>
              </div>

              <!-- Locations -->
              <div class="ti-review-row">
                <div class="ti-review-row__head">
                  <p class="ti-review-row__title">
                    <span class="ti-review-row__icon">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M12 21s-7-6.2-7-12a7 7 0 0 1 14 0c0 5.8-7 12-7 12z"
                        ></path>
                        <circle cx="12" cy="9" r="2.5"></circle>
                      </svg>
                    </span>
                    Locations
                  </p>
                  <button type="button" class="ti-link" (click)="goToStep(5)">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M4 20h4L19 9l-4-4L4 16v4z"></path>
                      <path d="M14 6l4 4"></path>
                    </svg>
                    Edit
                  </button>
                </div>
                <div class="ti-review-row__body">
                  <p class="ti-review-line ti-review-line--wide">
                    <span>Shipping location</span
                    >{{
                      joinFilled([
                        locationsGroup.get("ship_to_address")!.value,
                        locationsGroup.get("ship_city")!.value,
                        locationsGroup.get("ship_state")!.value,
                        locationsGroup.get("ship_pincode")!.value,
                      ])
                    }}
                  </p>
                  <p class="ti-review-line ti-review-line--wide">
                    <span>Factory / garden location</span
                    >{{
                      joinFilled([
                        locationsGroup.getRawValue().bill_to_address,
                        locationsGroup.getRawValue().bill_city,
                        locationsGroup.getRawValue().bill_state,
                        locationsGroup.getRawValue().bill_pincode,
                      ])
                    }}
                  </p>
                </div>
              </div>

              <!-- Signature -->
              <div class="ti-review-row">
                <div class="ti-review-row__head">
                  <p class="ti-review-row__title">
                    <span class="ti-review-row__icon">
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path
                          d="M3 17c3 0 4-9 6-9s1 8 3 8 2-4 4-4 2 3 5 3"
                        ></path>
                        <path d="M3 21h18"></path>
                      </svg>
                    </span>
                    Digital signature
                  </p>
                  <button type="button" class="ti-link" (click)="goToStep(6)">
                    <svg
                      width="14"
                      height="14"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path d="M4 20h4L19 9l-4-4L4 16v4z"></path>
                      <path d="M14 6l4 4"></path>
                    </svg>
                    Edit
                  </button>
                </div>
                <div class="ti-review-row__body">
                  <p class="ti-review-line ti-review-line--wide">
                    <span>Signature file (PDF)</span
                    >{{
                      signatureGroup.get("signatureFile")!.value?.name ||
                        "Not added"
                    }}
                  </p>
                </div>
              </div>
            </div>

            <label class="ti-checkbox-block">
              <input type="checkbox" formControlName="agreeTerms" />
              <span>
                I confirm the details provided are accurate and I agree to the
                Pan India Auction Rules and Tea Inntech's seller terms.
              </span>
            </label>
          </section>
        </ng-container>
      </div>

      <!-- footer nav -->
      <div class="ti-nav">
        <button
          type="button"
          class="ti-nav__back"
          [disabled]="step === 1"
          (click)="goBack()"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
          Back
        </button>

        <button
          *ngIf="step < 7"
          type="button"
          class="ti-btn ti-btn--amber"
          (click)="goNext()"
        >
          Continue
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <polyline points="9 18 15 12 9 6"></polyline>
          </svg>
        </button>

        <button
          *ngIf="step === 7"
          type="button"
          class="ti-btn ti-btn--forest btn"
          [disabled]="!canSubmit"
          (click)="submit($event)"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="1.9"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path
              d="M12 3l1.6 4.4L18 9l-4.4 1.6L12 15l-1.6-4.4L6 9l4.4-1.6L12 3z"
            ></path>
            <path d="M19 16l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7.7-2z"></path>
          </svg>
          <span class="indicator-label">Signup</span>
          <span class="indicator-progress">
            Please wait...
            <span
              class="spinner-border spinner-border-sm align-middle ms-2"
            ></span>
          </span>
        </button>
      </div>

      <p *ngIf="touched && !isStepValid(step)" class="ti-nav-error">
        Please fill in all required fields before continuing.
      </p>
    </div>
  </main>
</div>
